module.exports = new __parcel__URL__("oldEditorImage.very-specific-illu.51f0890e.png").toString();